var _path, _g, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_21350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 6.13353C13.9066 5.60433 14.913 5.71779 15.4838 6.40542L22.6238 15.0097C23.5558 16.0077 24.2076 15.8509 24.6142 15.4847C24.9593 15.1742 25.1145 14.7061 25.07 14.2442C25.0196 13.7242 25.03 12.7711 25.5042 11.5859C26.231 9.7685 28.2155 9.74391 29.2801 10.1113C29.9257 10.3338 30.1936 11.0967 29.8488 11.6862C29.3131 12.6012 28.6613 14.0459 28.8504 15.4247C29.1598 17.6806 30.5928 23.036 29.1544 25.6746C27.9415 27.8994 22.8629 34.4057 15.8585 28.2284C15.229 27.6732 13.3396 26.0623 11.4134 24.3937L11.1092 24.1299C9.7909 22.986 8.48551 21.8397 7.58471 21.0107C6.89988 20.3808 6.87797 19.3074 7.53552 18.6499L7.59858 18.59C8.24106 18.0114 9.23132 18.0314 9.84944 18.6499L13.5084 21.9449C13.5588 21.9953 13.6406 21.9953 13.6914 21.9449C13.7413 21.895 13.7417 21.8139 13.6925 21.7631L6.87528 14.7664C6.22273 14.1143 6.22273 13.0563 6.87528 12.4037L6.93963 12.3426C7.59529 11.7522 8.60649 11.7726 9.23762 12.4037L15.7766 18.5845C15.8297 18.6345 15.9123 18.6333 15.9638 18.5818L15.9824 18.5586C16.0138 18.509 16.0097 18.4432 15.9692 18.3978L8.46901 9.98372C7.8472 9.30234 7.89523 8.24549 8.577 7.6233L8.64408 7.56521C9.32611 7.00524 10.3353 7.07152 10.937 7.73129L18.5041 16.027C18.5552 16.0831 18.6424 16.085 18.6958 16.0316C18.7435 15.9839 18.7481 15.9082 18.7062 15.8552L12.9124 8.53949C12.3232 7.82929 12.4212 6.7759 13.131 6.18675L13.1986 6.13353Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_21350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38586 5.80176H30V30.8223H6.38586V5.80176Z",
    fill: "#B0B0D2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3553 3.2699C16.0905 3.32639 16.9464 3.6396 17.7457 4.1957C18.4436 4.68108 18.9828 5.27099 19.3141 5.8586",
    stroke: "#0D0A4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8209 1.01379C15.4704 0.908104 17.3062 1.40924 18.933 2.54064C20.3534 3.52832 21.3783 4.83266 21.9321 6.20118",
    stroke: "#0D0A4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00158 24.9346C6.28561 24.7575 5.49394 24.3067 4.79719 23.6261C4.18921 23.0319 3.75494 22.3613 3.52551 21.7268",
    stroke: "#0D0A4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1416 27.4132C6.49714 27.2445 4.76968 26.4467 3.35235 25.0616C2.11526 23.853 1.31974 22.3972 1 20.9557",
    stroke: "#0D0A4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.30ee9d1b5abf5e0b9b9e9eba7ddbfc76.svg";
export { ForwardRef as ReactComponent };